import * as React from 'react';
import {useEffect} from 'react';
import styled from "styled-components";

interface Props {

}

const PreloaderWrapper = styled.div`
  z-index: 2;
  width: 100vw;
  margin:auto;
  height: 100vh;
  position: fixed;
  display: flex;
  justify-content: center;
  align-items: center;
  backdrop-filter: blur(10px);
`

const PreloaderGif = styled.span`
  position: absolute;
`

const Preloader : React.FC<Props> = props => {
    useEffect(() => {
        const preventScroll = (e: any) => {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }

        return (() => {
            document.querySelector("html")?.removeEventListener("wheel", preventScroll);
        })
    }, []);

    return <>
        <PreloaderWrapper id={"preloader"}>
            <PreloaderGif className={'pi text-primary-600 pi-spin fas fa-circle-notch'} style={{ fontSize: '5rem' }}/>
        </PreloaderWrapper>
    </>
};

export default Preloader
